import React, { useState } from "react"; 
import { useNavigate } from "react-router-dom"; 
import send from "../images/reshot-icon-send-message.png"; 

import "./Thankyou.css"; 

  

function ThankYouPage() { 


  const navigate = useNavigate(); 

  

  return ( 

    <div className="thankYouCard"> 

      <img src={send} style={{ width: "40%" }} /> 

      <p className="cookieHeading">Thank You !</p> 

      <p className="cookieDescription"> 

        We got your request. We are working on your request. <br /> 

      </p> 

  

      <div className="buttonContainer"> 

        <button 

          className="acceptButton" 

          onClick={() => { 

            navigate("/"); 

          }}> 

          Go Back 

        </button> 
      </div> 

    </div> 

  ); 

} 

export default ThankYouPage; 

 